<template>
  <div>
    <b-form-checkbox
      id="select-all-menu-record-permissions"
      v-model="allSelected"
      name="select-all-menu-record-permissions"
      class="text-capitalize mt-2"
      switch
    >
      {{ $t('hanwha_dvr.groups_permissions.select_all') }}
    </b-form-checkbox>
    <b-list-group>
      <b-list-group-item>
        <div class="row">
          <div
            v-for="(option, index) in recordOptions"
            :key="index"
            class="col-6"
          >
            <b-form-checkbox
              :id="`option-${option.value}`"
              v-model="itemData.RecordMenuAccess"
              :name="option.value"
              class="mt-1 text-capitalize"
              switch
              :value="option.value"
            >
              {{ option.label }}
            </b-form-checkbox>
          </div>
        </div>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import { useArraySelectAllSwitch, flattenOptionValues } from "./useSelectAllSwitch";

export default {
  props: {
    itemData: {
      type: Object
    }
  },
  setup (props) {
    //COMPOSABLES
    const { t } = useI18nUtils();

    //DATA
    const recordOptions = [
      {
        label: t('hanwha_dvr.groups_permissions.menu.record.recording_schedule'),
        value: 'RecordingSchedule'
      },
      {
        label: t('hanwha_dvr.groups_permissions.menu.record.record_setup'),
        value: 'NvrRecordSetup'
      },
      {
        label: t('hanwha_dvr.groups_permissions.menu.record.record_option'),
        value: 'RecordOption'
      }
    ];

    // Purge 'NvrRecordSetup,', saved by a former typo, so no group keeps both variants.
    const { allSelected } = useArraySelectAllSwitch(
      props.itemData,
      "RecordMenuAccess",
      flattenOptionValues(recordOptions),
      ["NvrRecordSetup,"]
    );

    return { allSelected, recordOptions }
  }
}
</script>
